import { loadRemoteAndHandshake } from "asos-web-secure-script-container";
import clientConfig from "@template/clientConfig";

const { SECURE_SCRIPT_CONTAINER_DOMAIN } = clientConfig.get();

export default () => {
  loadRemoteAndHandshake({ containerDomain: SECURE_SCRIPT_CONTAINER_DOMAIN });
};
